// extracted by mini-css-extract-plugin
module.exports = {"login_signup_wrapper":"LoginSignupButtons_login_signup_wrapper__tcS2q","button_style":"LoginSignupButtons_button_style__RkKwl"};